import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
import { HomeService } from '../booking-services/home.service';
import { DynamicSearchDetailResponse,DynamicSearchObject, pageType } from '../../models/dynamic-pages';
import { SEARCH_CURRENCY_CODE } from '../../app-constants';
import { formatDateGeneral } from '../../common/Utilities/date-utilities';
import { Title, Meta } from '@angular/platform-browser';
@Component({
    selector: 'dynamic-search',
    templateUrl: 'dynamic-search.component.html',
    styleUrls:['dynamic-search.component.css']
})

export class DynamicSearchComponent implements OnInit {
    constructor(private _homeService:HomeService,private route: ActivatedRoute,private router: Router,private titleService: Title, private metaService: Meta) { }
    id:string;

    deptDatePickerOptions: IMyDpOptions;
    retDatePickerOptions: IMyDpOptions;

    originName: any;
    destinationName: any;
    travellers: any;
    searchFromDate: any;
    searchToDate: any;
    flightCount = 0;
    flightSearchDates: any = {};

    FromLocationObj:any;
    ToLocationObj:any;
    TripType: string;
    searchObj:any;
    image:any;
    isOneWayRouteSelected = false;
    dynaicPageDetail:DynamicSearchObject = {name:"",content:"",createdDate:null,fromAirport:"",fromAirportCode:"",id:1,image:"",language:"",metaDescription:"",metaKeywords:"",metaTitle:"",title:"",toAirport:"",toAirportCode:"",type:pageType.Blog};


    ngOnInit() {
        this.id = this.route.snapshot.paramMap.get('id');
        this.loadPageContent(this.id);
     }

     getUrl()
{
  return "url('"+this.image+"')";
}


    loadPageContent(id:string){
        this._homeService.getDynamicPageDetail(id).subscribe((response:DynamicSearchDetailResponse) =>{
          //  console.log(response);
            if(response.status == true){
                this.dynaicPageDetail = response.data[0];
                var origin = {"Code":this.dynaicPageDetail.fromAirportCode,"Name":this.dynaicPageDetail.fromAirport,"Type":0}
                localStorage.setItem('origin',JSON.stringify(origin));
                this.FromLocationObj = origin;

                var destination = {"Code":this.dynaicPageDetail.toAirportCode,"Name":this.dynaicPageDetail.toAirport,"Type":0};
                localStorage.setItem('destination',JSON.stringify(destination));
                this.ToLocationObj = destination;

                sessionStorage.setItem('TripType','O');
                this.TripType ='O';

                var rq = {"PoolRequest":
                {"Routes":
                [
                    {"Origin":{"Code":response.data[0].fromAirportCode,"IsCity":false},
                    "Destination":{"Code":response.data[0].toAirport,"IsCity":false}
                ,"Departure":{"Date":formatDateGeneral(new Date()),"DaysBefore":1}
                ,"FlightType":{"MaxConnections":0,"ConnectionType":4}}
              ],"Passengers":{"Adult":1,"Child":0,"Infant":0}
              ,"Preference":{"RequiredCarrierCodes":null,"CabinType":null}},
              "CurrencyCode":SEARCH_CURRENCY_CODE}
  
              this.searchObj = rq;
              this.image = response.data[0].image;

              sessionStorage.setItem('SearchObj',JSON.stringify(rq));

               this.titleService.setTitle(this.dynaicPageDetail.metaTitle);
                this.metaService.addTags([
                  {name: 'keywords', content: this.dynaicPageDetail.metaKeywords},
                  {name: 'description', content: this.dynaicPageDetail.metaDescription},
                  {name: 'robots', content: 'index, follow'}
                ]);  

                if(this.dynaicPageDetail.type === pageType.Country || this.dynaicPageDetail.type === pageType.Location){
                  const title = "vliegtickets "+this.dynaicPageDetail.title;
                  this.dynaicPageDetail.title = title;
                }
            }
           
        });
    }
    

    setDatePickerDefaults() {
        const currentDate = new Date();
        const previousDate = new Date();
        this.searchFromDate = this.searchToDate = { date: { day: currentDate.getDate(), month: currentDate.getMonth() + 1,
                              year: currentDate.getFullYear()} }; // getMonth index starts from 0
        previousDate.setDate(currentDate.getDate() - 1);
        const nextDate =  new Date();
        nextDate.setDate(currentDate.getDate() + 1);
        this.searchToDate = { date: { day: nextDate.getDate(), month: nextDate.getMonth() + 1, year: nextDate.getFullYear()} };
        this.deptDatePickerOptions.disableUntil = { day: previousDate.getDate(), month: previousDate.getMonth() + 1,
                                                    year: previousDate.getFullYear() };
        this.retDatePickerOptions.disableUntil = { day: previousDate.getDate(), month: previousDate.getMonth() + 1,
                                                    year: previousDate.getFullYear() };
        this.flightSearchDates.departure = currentDate;
        this.flightSearchDates.fromDate = currentDate.getFullYear() + '-' + JSON.stringify(currentDate.getMonth() + 1) + '-' + currentDate.getDate();
        this.flightSearchDates.toDate = nextDate.getFullYear() + '-' + JSON.stringify(currentDate.getMonth() + 1) + '-' + nextDate.getDate();
      }

    editResponse($event) {
        !this.isOneWayRouteSelected ? this.searchFromDate = $event.searchdate : this.searchToDate = $event.searchdate;
        this.travellers = $event.travellers;
        this.originName = $event.originName;
        this.destinationName = $event.destinationName;
        // if ($event.dayType === '') {
        //   this.isEdit = $event.isEdit;
        //   this.searchEdit = !this.searchEdit;
        // }
      }
}